import { getTenant } from '../helpers';
import { api } from './api';
import { callMainTenantAPIsOnly } from './helpers';

export function getTimeSpentUserDataAPI(username: string, callback) {
  const today = new Date();

  // Calculate the first day of the week (6 days before today)
  const firstDayOfWeek = new Date(today);
  firstDayOfWeek.setDate(today.getDate() - 6);

  const formattedFirstDay = formatDate(firstDayOfWeek);
  const formattedLastDay = formatDate(today);

  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdperlearner.perlearnerOrgsUsersOverviewTimeOverTimeRetrieve(
        ...args
      ),
    getTenant(),
    username,
    {
      endDate: formattedLastDay,
      startDate: formattedFirstDay,
    }
  )((err, data, response) => console.log(err, callback(data?.data), response));
}

export function getUserActivityDataAPI(username, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdperlearner.perlearnerOrgsUsersInfoRetrieve(...args),
    getTenant(),
    username,
    { meta: 'true' }
  )((err, data, response) => console.log(err, callback(data), response));
}

export function getMostPopularCourseAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdperlearner.perlearnerOrgsUsersActivityRetrieve(...args),
    getTenant(),
    username,
    {}
  )((err, data, response) => findMostPopularCourse(callback, data?.data));
}

function getCourseWithMostTime(data) {
  let courseWithMostTime = null;
  let maxTimeInvested = -1;

  data?.forEach(function (course) {
    const timeInvested = parseInt(course?.time_invested);

    if (timeInvested > maxTimeInvested) {
      maxTimeInvested = timeInvested;
      courseWithMostTime = course;
    }
  });

  return courseWithMostTime;
}
function findMostPopularCourse(callback, data) {
  const courseWithMostTime = getCourseWithMostTime(data);
  callback(courseWithMostTime);
}

export function getUserSkillLeaderBoardAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdskillsapi.skillsOrgsSkillsUsersPointPercentileRetrieve(...args),
    getTenant(),
    username
  )((err, data, response) => console.log(err, callback(data), response));
}

const fetchPathwaysAndResourcesData = (tenantKey: string, username: string) => {
  return new Promise<any[]>((resolve, reject) => {
    const requestData = {
      username: username,
      platform_key: tenantKey,
    };

    api.ibledxpathway.getUserPathways(
      requestData,
      (data) => {
        resolve(data || []);
      },
      (error) => {
        console.error('getUserPathwaysAndResourcesTotalAPI: ', error);
        reject(error);
      }
    );
  });
};

export function getUserPathwaysAndResourcesTotalAPI(
  username: string,
  callback
) {
  const tenant = getTenant();
  fetchPathwaysAndResourcesData(tenant, username)
    .then((data) => {
      const uniqueData = filterUniquePathways(data);
      const aggregatedData = aggregatePathwaysAndResources(uniqueData);
      callback(aggregatedData);
    })
    .catch((error) => {
      console.error(error);
      callback({ pathways: 0, totalResources: 0 });
    });
}

const filterUniquePathways = (data) => {
  const seen = new Set();
  return data.filter((item) => {
    const duplicate = seen.has(item.id);
    seen.add(item.id);
    return !duplicate;
  });
};

const aggregatePathwaysAndResources = (data) => {
  let totalResources = 0;
  data.forEach((pathway) => {
    totalResources += pathway.path?.length || 0;
  });
  return {
    pathways: data?.length,
    totalResources: totalResources,
  };
};

const fetchTotalCredentialsData = (tenantKey: string, username: string) => {
  return new Promise<number>((resolve, reject) => {
    api.iblaxdApiCallWrapper(
      (args) =>
        api.iblaxdcredapi.credentialsOrgsUsersAssertionsRetrieve(...args),
      tenantKey,
      username,
      {}
    )((err, data, response) => {
      if (response.status !== 200 || err) {
        console.error('getUserTotalCredentialsAPI: ', err);
        reject(err);
      } else {
        const length = Array.isArray(response?.body)
          ? response.body[0]?.data?.length
          : 0;
        resolve(length);
      }
    });
  });
};

export function getUserTotalCredentialsAPI(username: string, callback) {
  const tenant = getTenant();
  const shouldCallMainTenantOnly = callMainTenantAPIsOnly();

  fetchTotalCredentialsData(tenant, username)
    .then(callback)
    .catch((error) => {
      console.error(error);
      callback(0);
    });

  // if (tenant === 'main' || shouldCallMainTenantOnly) {
  //   // Fetch total credentials data for the main tenant only
  //   fetchMainCredentials()
  //     .then(callback)
  //     .catch((error) => {
  //       console.error(error);
  //       callback(0);
  //     });
  // } else {
  //   // Fetch total credentials data for both the current tenant and the main tenant
  //   Promise.all([
  //     fetchTotalCredentialsData(tenant, username).catch((error) => {
  //       console.error(error);
  //       return 0; // Returning 0 in case of error for main tenant
  //     }),
  //     fetchMainCredentials().catch((error) => {
  //       console.error(error);
  //       return 0; // Returning 0 in case of error for main tenant
  //     }),
  //   ])
  //     .then((results) => {
  //       // Sum up the lengths from both tenants
  //       const totalLength = results.reduce((acc, length) => acc + length, 0);
  //       callback(totalLength);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       callback(0);
  //     });
  // }
}

export function calculateDaysTotal(data) {
  const daysTotal = {};
  for (const date in data) {
    if (data?.hasOwnProperty(date)) {
      const [year, month, day] = date.split('-');
      const key = `${year}-${month}-${day}`;
      if (daysTotal.hasOwnProperty(key)) {
        daysTotal[key] += (data[date] / 60).toFixed(0);
      } else {
        daysTotal[key] = (data[date] / 60).toFixed(0);
      }
    }
  }
  return daysTotal;
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
